<form [formGroup]="rationaleForm">
  <mat-card class="detail-card" style="padding: unset">
    <mat-card-header class="detail-card-header">
      <mat-card-title>Valuation Rationale</mat-card-title>
    </mat-card-header>
    <mat-card-content class="detail-card-content">
      @if (!rationaleIsEditable && assetValuation.rationale.text) {
        <div class="line-breaks">
          {{assetValuation.rationale.text}}
        </div>
      } @else {
        @if (!rationaleIsEditable) {
          <div class="no-description" style="color: grey">
            Please add a valuation rationale!
          </div>
        }
      }


      @if (rationaleIsEditable) {
        <mat-form-field appearance="fill" style="display: unset">
          <textarea class="line-breaks"
            data-test="rationale"
            formControlName="rationale"
            matInput
            style="height: 250px">
          </textarea>
        </mat-form-field>
      }
    </mat-card-content>

    <mat-card-actions class="detail-card-actions">
      @if (!rationaleIsEditable) {
        <button (click)="edit()"
          [disabled]="(isEditDisabled$ | async)!"
          color="primary"
          data-test="edit-rationale-button"
          mat-icon-button>
          <mat-icon>edit</mat-icon>
        </button>
      }
      @if (rationaleIsEditable) {
        <button (click)="save()"
          [disabled]="rationaleForm.invalid"
          color="primary"
          data-test="save-button"
          mat-icon-button>
          <mat-icon>save</mat-icon>
        </button>
      }
      @if (rationaleIsEditable) {
        <button (click)="cancel()"
          color="primary"
          data-test="cancel-rationale-button"
          mat-icon-button>
          <mat-icon>cancel</mat-icon>
        </button>
      }
    </mat-card-actions>
  </mat-card>
</form>
